import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import { dailyShareNOK } from '@api/analytics';
import { ApiResponse } from '@typings/ApiResponse';
import { DailyShareNOK } from '@typings/Analytics';
import { ShareNOKChartData } from '../../types';

interface DailyChartProps {
  partnerCarehomeId: string;
}
const DailyChart: React.FC<DailyChartProps> = ({ partnerCarehomeId }) => {
  const [dailyData, setDailyData] = useState<ShareNOKChartData[]>([
    {
      name: '',
      Shared: 0,
      'Not shared': 0,
    },
  ]);

  useEffect(() => {
    const getDailyData = async () => {
      try {
        const res: ApiResponse<DailyShareNOK[]> =
          await dailyShareNOK(partnerCarehomeId);
        if (res?.data) {
          const tranformedData = res.data?.map((item: DailyShareNOK) => {
            const { date, nextOfKin, total } = item;
            return {
              name: dayjs(date).format('MMM D'),
              Shared: nextOfKin,
              'Not shared': total - nextOfKin,
            };
          });
          setDailyData(tranformedData);
        }
      } catch (error) {
        console.error('Error fetching daily data:', error);
      }
    };
    if (partnerCarehomeId) {
      getDailyData();
    }
  }, [partnerCarehomeId]);

  return (
    <div className="mb-10">
      <h3 className="govuk-heading-s chart-title">Daily (last 7 days)</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={dailyData}
          margin={{
            top: 20,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="Shared" stackId="a" fill="#005eb8" />
          <Bar dataKey="Not shared" stackId="a" fill="#d4351c" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default DailyChart;
